import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface DebugState {
  isDebugOpen: boolean;
  toggleDebug: () => void;
  openDebug: () => void;
  closeDebug: () => void;
}

export const useDebugStore = create<DebugState>()(
  devtools(
    set => ({
      isDebugOpen: false,

      toggleDebug: () => set(state => ({ isDebugOpen: !state.isDebugOpen })),

      openDebug: () => set({ isDebugOpen: true }),

      closeDebug: () => set({ isDebugOpen: false }),
    }),
    {
      name: 'debug-store',
    }
  )
);
